if (document.getElementById('vue-manage')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: [ '[[', ']]' ],
		mixins: [ baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin ],
		el: '#vue-manage',
		data: {
			filters: {
				partners: {
					options: [],
					model: {}
				},
				search: ''
			},
			records: [],
			user: {}
		},
		created() {},
		mounted() {
			this.user = JSON.parse(localStorage.getItem('user'));
			this.getRecords();
			this.getCollaborators();
		},
		computed: {
			filteredRecords() {
				let results = [];
				if (this.filters.search !== '' || this.filters.partners.model.value !== '') {
					if (this.filters.search !== '') {
						results = this.records.filter((el) => {
							let string =
								el.residences.join() +
								el.get_application_status_display +
								el.application_date +
								el.scepia_candidate_id +
								el.first_name +
								el.last_name +
								el.collaborator_partner_obj.get_full_name;
							if (string.toUpperCase().includes(this.filters.search.toUpperCase())) {
								return el;
							}
						});
					}
					if (this.filters.partners.model.value !== '') {
						this.filters.search === '' && (results = this.records);
						return results.filter((el) => this.filters.partners.model.value === el.collaborator_partner);
					}

					return results;
				}
				return this.records;
			},
            exportUrl() {
                if (this.filters.search !== '' || this.filters.partners.model.value !== '') {
                    const params = new URLSearchParams();
                    this.filteredRecords.forEach((el) => params.append('residents', el.id));
                    return '?' + params.toString();
                } else {
                    return ''
                }
            },
		},
		methods: {
			getCollaborators() {
				this.get('collaborators')
					.then((response) => {
						this.filters.partners.options = response.data.results.map((el) => ({
							label: el.get_full_name,
							value: el.id
						}));
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			getRecords() {
				this.get('residents', { limit: 8000 })
					.then((response) => {
						this.records = response.data.results;
						this.records.map((el) => (el.displayConfirm = false));
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			deleteRecord(id) {
				this.patch('residents/' + id + '/cancel-application')
					.then((response) => {
						this.records.find((el) => el.id === id).displayConfirm = false;
						this.getRecords();
						// console.log(response);
					})
					.catch((error) => {
						this.records.find((el) => el.id === id).displayConfirm = false;
						// console.log(error);
					});
			},
			toggleDisplayConfirm(id) {
				let record = this.records.find((el) => el.id === id);
				let index = this.records.findIndex((el) => el.id === id);
				this.$set(this.records, index, {
					...record,
					displayConfirm: !record.displayConfirm
				});
			}
		}
	});
}
